const PASSWORD_LENGTH = 16;
const UINT32_RANGE = 0x100000000;

// Characters that are easy to confuse when read or typed are left out.
const DIGITS = '34679';
const UPPERCASE = 'ACDEFGHJKMNPQRTWXY';
const LOWERCASE = 'abcdefghjkmnpqrtuvwxyz';
const ALPHABET = DIGITS + UPPERCASE + LOWERCASE;

// Rejection sampling keeps the result unbiased when max does not divide 2^32.
function randomIndex(max) {
  const limit = UINT32_RANGE - (UINT32_RANGE % max);
  const buffer = new Uint32Array(1);
  do {
    window.crypto.getRandomValues(buffer);
  } while (buffer[0] >= limit);
  return buffer[0] % max;
}

function randomChar(characters) {
  return characters[randomIndex(characters.length)];
}

export function generatePassword() {
  const characters = [randomChar(UPPERCASE), randomChar(LOWERCASE), randomChar(DIGITS)];
  while (characters.length < PASSWORD_LENGTH) {
    characters.push(randomChar(ALPHABET));
  }
  for (let i = characters.length - 1; i > 0; i--) {
    const j = randomIndex(i + 1);
    [characters[i], characters[j]] = [characters[j], characters[i]];
  }
  return characters.join('');
}
